import pngFrame1420 from "./assets/frame-1420--osize-385px--isize-249px.png";
import pngFrame1422 from "./assets/frame-1422--osize-385px--isize-249px.png";
import pngFrame1425 from "./assets/frame-1425--osize-385px--isize-249px.png";
import pngFrame1427 from "./assets/frame-1427--osize-385px--isize-249px.png";
import pngFrame1428 from "./assets/frame-1428--osize-385px--isize-249px.png";
import pngFrame1429 from "./assets/frame-1429--osize-385px--isize-249px.png";
import pngFrame1430 from "./assets/frame-1430--osize-320px--isize-206px.png";

export const FRAME = {
  frame1420: { src: pngFrame1420, osize: 385, isize: 249 },
  frame1422: { src: pngFrame1422, osize: 385, isize: 249 },
  frame1425: { src: pngFrame1425, osize: 385, isize: 249 },
  frame1427: { src: pngFrame1427, osize: 385, isize: 249 },
  frame1428: { src: pngFrame1428, osize: 385, isize: 249 },
  frame1429: { src: pngFrame1429, osize: 385, isize: 249 },
  frame1430: { src: pngFrame1430, osize: 320, isize: 206 },
};

export type FrameKey = keyof typeof FRAME;

export function isFrameKey(value: string): value is FrameKey {
  return Object.keys(FRAME).includes(value);
}
